class LoginDelegate {
    setEmail(email) {
        const next = { email };
        if (this.state.error) {
            next.error = false;
            next.errorMessage = '';
        }
        this.setState(next);
    }

    setPassword(password) {
        const next = { password };
        if (this.state.error) {
            next.error = false;
            next.errorMessage = '';
        }
        this.setState(next);
    }
}

export default LoginDelegate;
